import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const MILEAGE_REPORTS_LIST = (params) => { return URI(`${API_BASE}/api/v2/driver_logs/driver_reports/`).addSearch(params) }
export const MILEAGE_REPORT_CREATE = (params) => { return URI(`${API_BASE}/api/v2/driver_logs/driver_reports/`).addSearch(params) }
export const MILEAGE_REPORT_INFO = ({id, ...params}) => { return URI(`${API_BASE}/api/v2/driver_logs/driver_reports/${id}/`).addSearch(params) }
export const MILEAGE_GET_LAST_ITEM = () => { return URI(`${API_BASE}/api/v2/driver_logs/driver_reports/?p=1&per_page=1&order=created_at+desc`) }
